import { render, staticRenderFns } from "./room-type-inventory.vue?vue&type=template&id=0810f9ca&scoped=true"
import script from "./room-type-inventory.vue?vue&type=script&lang=js"
export * from "./room-type-inventory.vue?vue&type=script&lang=js"
import style0 from "./room-type-inventory.vue?vue&type=style&index=0&id=0810f9ca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0810f9ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0810f9ca')) {
      api.createRecord('0810f9ca', component.options)
    } else {
      api.reload('0810f9ca', component.options)
    }
    module.hot.accept("./room-type-inventory.vue?vue&type=template&id=0810f9ca&scoped=true", function () {
      api.rerender('0810f9ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/property/room-type-inventory.vue"
export default component.exports